<script setup>
import AutocompleteFilter from '@/components/widgets/AutocompleteFilter.vue';
import { inject, onMounted, ref } from 'vue';
import { useInfinite } from '@/composables/use-infinity';

const backendApi = inject('backendApi');

const emit = defineEmits(['update', 'update:focused']);
defineProps({
    hideLabel: {
        type: Boolean,
        default: false
    }
});

const selected = ref(null);

const fetchCarriers = ({ pattern, page, limit }) =>
    backendApi().carrier().index({
        pattern,
        active: true,
        page,
        limit
    });

const {
    items: carriers,
    loading: isLoading,
    showRetryButton,
    hasMore,
    searchQuery,
    getItems,
    loadMore,
    reset
} = useInfinite(fetchCarriers);

const handleSearch = () => {
    reset();
    getItems();
};

onMounted(() => {
    getItems();
});
</script>

<template>
    <AutocompleteFilter
        v-model="selected"
        v-model:search="searchQuery"
        :items="carriers"
        item-title="name"
        item-value="id"
        :label="hideLabel ? '' : $t('Carrier')"
        :loading="isLoading"
        :show-retry-button="showRetryButton"
        :infinite-scroll="hasMore"
        @infinite-scroll="loadMore"
        @update="emit('update', selected)"
        @preparing-search="handleSearch"
        @search="handleSearch"
        @retry="handleSearch"
        @update:focused="(state) => emit('update:focused', state)"
    >
        <template v-slot:default="{ props, item }">
            <v-list-item
                v-bind="props"
                :title="`${item.raw.name}`"
                :subtitle="`${
                    item.raw.description ? item.raw.description : ''
                }`"
            ></v-list-item>
        </template>
        <template v-if="$slots.prepend" v-slot:prepend>
            <slot name="prepend"></slot>
        </template>
    </AutocompleteFilter>
</template>
